// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const commentInAttachmentIdsMax = 10;

export const commentInBodyMax = 4000;

export const CommentIn = zod.object({
  "attachment_ids": zod.array(zod.uuid()).max(commentInAttachmentIdsMax).optional(),
  "body": zod.string().min(1).max(commentInBodyMax)
});

export type CommentIn = zod.input<typeof CommentIn>;
export type CommentInOutput = zod.output<typeof CommentIn>;
